import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../store/createStore';
import { useCheckoutFunction } from '../../hooks/useCheckoutFunctions';
import { checkoutActionTypes } from '../../store/modules/checkout/types';
import { RoundHelper } from '../../utils/roundHelper';

// import { useHistory } from 'react-router-dom';

// import { MdClose } from 'react-icons/md';
// import { useSelector, useDispatch } from 'react-redux';

// import {
//   Root,
//   ContainerMyCart,
//   MyCartTitle,
//   ProductsList,
//   ProductRow,
//   ContainerImagem,
//   ProductImagem,
//   ContainerDetal,
//   ProductTitle,
//   ProductCategory,
//   ProductPrice,
//   ContainerQty,
//   QtyTitle,
//   Botton,
//   CotainerActions,
//   PlusIcon,
//   InputQty,
//   MinusIcon,
//   DeleteIcon,
//   ContainerRemove,
//   ButtonRemove,
//   ContainerActions,
//   KeepBuyingBtn,
//   CheckoutBtn,
// } from './styles';
// import { StoreState } from '../../store/createStore';
// import {
//   checkoutActionTypes,
// } from '../../store/modules/checkout/types';
// import {
//   checkoutAddPlu,
//   checkoutRemovePlu,
// } from '../../store/modules/checkout/actions';

// import { ProductData } from '../../store/modules/product/types';
// import { setIsCategory } from '../../store/modules/parameter/actions';

const Checkout: React.FC = () => {
  const { checkout } = useSelector((state: StoreState) => state.checkout);
  const { handleCheckoutActions } = useCheckoutFunction();

//   const { user } = useSelector((state: StoreState) => state.auth);

//   const { checkout, summary } = useSelector(
//     (state: StoreState) => state.checkout,
//   );

//   const dispatch = useDispatch();
//   const history = useHistory();

//   const handleCheckoutActions = useCallback(
//     async (type: string, product?: ProductData) => {
//       if (Number(checkout.items_count) < 1) return;
//       //konsole.log('handleCheckoutActions: ', data, product);
//       switch (type) {
//         case checkoutActionTypes.ADD_PLU_CHECKOUT:
//           if (product) dispatch(checkoutAddPlu(product));
//           break;
//         case checkoutActionTypes.REMOVE_PLU_CHECKOUT:
//           if (summary?.id) {
//             if (product) dispatch(checkoutRemovePlu(summary?.id, product));
//           }
//           else {
//             if (product) dispatch(removePlu(product));
//           }
//           break;
//         case checkoutActionTypes.ADD_PLU_QTY_CHECKOUT:
//           if (product) dispatch(checkoutAddQtyPlu(product));
//           break;
//         case checkoutActionTypes.REMOVE_PLU_QTY_CHECKOUT:
//           if (product) dispatch(checkoutRemoveQtyPlu(product));
//           break;
//         case checkoutActionTypes.FINISH_CHECKOUT:
//           if (!summary?.id) dispatch(checkoutSend(user, checkout));
//           else dispatch(checkoutFind(summary?.id, checkout));
//           history.push('/summary');
//           break;
//         default:
//       }
//     },
//     [dispatch, checkout, history, summary, user],
//   );

//   const handleCheckoutSale = useCallback(() => {
//     history.push('/produtos');
//   }, [history]);

//   useEffect(() => {
//     dispatch(setIsCategory(false));
//   }, [dispatch]);

//   return (
//     <Root>
//       <ContainerMyCart>
//         <MyCartTitle>
//           {checkout.items_count === 0 ? (
//             <span>Carrinho vazio :( </span>
//           ) : (
//               <span>Meu Carrinho</span>
//             )}
//         </MyCartTitle>
//         <ProductsList>
//           <>
//             {checkout.items &&
//               checkout.items.map(item => (
//                 <ProductRow key={item.id}>
//                   <ContainerImagem>
//                     <ProductImagem>
//                       <img
//                         src={item.product.image_url}
//                         alt={item.short_description}
//                       />
//                     </ProductImagem>
//                   </ContainerImagem>
//                   <ContainerDetal>
//                     <ProductTitle>
//                       <span>{item.short_description}</span>
//                     </ProductTitle>
//                     <ProductCategory>
//                       <span>{item.product.category?.long_description}</span>
//                     </ProductCategory>
//                     <ProductPrice>
//                       <span> {Number(item.price).toFixed(2)}</span>
//                     </ProductPrice>
//                   </ContainerDetal>
//                   <ContainerQty>
//                     <QtyTitle>
//                       <span>Quantidade</span>
//                     </QtyTitle>
//                     <CotainerActions>
//                       <Botton
//                         onClick={() =>
//                           handleCheckoutActions(
//                             checkoutActionTypes.ADD_PLU_QTY_CHECKOUT,
//                             item.product,
//                           )}
//                       >
//                         <PlusIcon size={24} />
//                       </Botton>
//                       <InputQty value={item.quantity} />
//                       <Botton
//                         onClick={() =>
//                           handleCheckoutActions(
//                             Number(item.quantity) === 1 ?
//                               checkoutActionTypes.REMOVE_PLU_CHECKOUT :
//                               checkoutActionTypes.REMOVE_PLU_QTY_CHECKOUT,
//                             item.product,
//                           )}
//                       >
//                         {Number(item.quantity) === 1 ? (
//                           <DeleteIcon />
//                         ) : (
//                             <MinusIcon />
//                           )}

//                       </Botton>
//                     </CotainerActions>
//                   </ContainerQty>
//                   <ContainerRemove>
//                     <ButtonRemove
//                       onClick={() =>
//                         handleCheckoutActions(
//                           checkoutActionTypes.REMOVE_PLU_CHECKOUT,
//                           item.product,
//                         )}
//                     >
//                       <span>EXCLUIR PRODUTO</span>
//                       <MdClose color="#FFF" />
//                     </ButtonRemove>
//                   </ContainerRemove>
//                 </ProductRow>
//               ))}
//           </>
//         </ProductsList>
//       </ContainerMyCart>
//       <ContainerActions>
//         <KeepBuyingBtn onClick={handleCheckoutSale}>
//           <span>CONTINUAR COMPRANDO</span>
//         </KeepBuyingBtn>
//         <CheckoutBtn
//           disabled={checkout.items_count === 0 ? true : false}
//           onClick={() => checkout.items_count === 0 ?
//             null :
//             handleCheckoutActions(checkoutActionTypes.FINISH_CHECKOUT, undefined)
//           }
//         >
//           <span>FINALIZAR COMPRA</span>
//         </CheckoutBtn>
//       </ContainerActions>
//     </Root>
//   );

  // Adicione um estado local para os inputs do carrinho
  const [inputValues, setInputValues] = React.useState<Record<string, string>>({});

    return (
    <div style={{ padding: 32 }}>
      <h2>Meu Carrinho</h2>
      {checkout.items && Object.keys(checkout.items).length > 0 ? (
        Object.values(checkout.items).map(item => {
          const isKg = item.product?.un === 'Kg';
          // quantity pode vir como string, garantir parseFloat
          const currentQty = parseFloat(item.quantity);
          // Para exibição: sempre 3 casas decimais e vírgula para kg
          const displayQty = isKg
            ? `${Number(currentQty).toFixed(3).replace('.', ',')}kg`
            : Math.floor(currentQty);
          return (
            <div key={item.id} style={{ display: 'flex', alignItems: 'center', marginBottom: 24, background: '#f5f5f5', borderRadius: 8, padding: 16 }}>
              <img src={item.product?.image_url} alt={item.short_description} style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, marginRight: 16 }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 'bold' }}>{item.short_description}</div>
                <div style={{ color: '#888' }}>{item.product?.category?.long_description}</div>
                <div style={{ color: '#c00', fontWeight: 'bold', marginTop: 8 }}>{RoundHelper.toFormatted(item.price)}</div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button
                  style={{ fontSize: 24, width: 32, height: 32, borderRadius: 16, border: 'none', background: '#eee', cursor: 'pointer' }}
                  onClick={() => {
                    // Pega o valor do input se existir, senão do carrinho
                    let baseQty = inputValues[item.id] !== undefined
                      ? parseFloat(inputValues[item.id].replace(',', '.'))
                      : parseFloat(item.quantity);
                    let newQty;
                    if (isKg) {
                      newQty = Math.max(0, Number((baseQty - 0.1).toFixed(3)));
                    } else {
                      newQty = Math.max(0, Math.floor(baseQty - 1));
                    }
                    if (newQty === 0) {
                      handleCheckoutActions(
                        checkoutActionTypes.REMOVE_PLU_CHECKOUT,
                        item.product?.product_id || '',
                        "0"
                      );
                      setInputValues(prev => ({ ...prev, [item.id]: '' }));
                    } else {
                      const qtyToSend = isKg ? newQty.toFixed(3) : String(newQty);
                      setInputValues(prev => ({
                        ...prev,
                        [item.id]: isKg ? qtyToSend.replace('.', ',') : qtyToSend,
                      }));
                      handleCheckoutActions(
                        checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                        item.product?.product_id || '',
                        qtyToSend,
                      );
                    }
                  }}
                >
                  –
                </button>
                <input
                  style={{ width: 70, textAlign: 'center', fontSize: 18 }}
                  value={
                    inputValues[item.id] !== undefined
                      ? inputValues[item.id]
                      : displayQty
                  }
                  onChange={e => {
                    let value = e.target.value.replace(',', '.');
                    // Permite apenas números, ponto e vazio
                    if (/^\d*\.?\d*$/.test(value) || value === '') {
                      setInputValues(prev => ({
                        ...prev,
                        [item.id]: value.replace('.', ',')
                      }));
                    }
                  }}
                  onBlur={e => {
                    let value = e.target.value.replace(',', '.');
                    const num = parseFloat(value);
                    if (!isNaN(num) && num > 0) {
                      const formatted = isKg ? num.toFixed(3) : String(Math.floor(num));
                      setInputValues(prev => ({
                        ...prev,
                        [item.id]: isKg
                          ? formatted.replace('.', ',') + 'kg'
                          : formatted,
                      }));
                      handleCheckoutActions(
                        checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                        item.product?.product_id || '',
                        isKg ? formatted : String(Math.floor(num))
                      );
                    } else {
                      setInputValues(prev => ({
                        ...prev,
                        [item.id]: '',
                      }));
                      // Se quiser remover o item se zerar, pode chamar REMOVE_PLU_CHECKOUT aqui
                    }
                  }}
                  inputMode={isKg ? 'decimal' : 'numeric'}
                  placeholder="0"
                />
                <button
                  style={{ fontSize: 24, width: 32, height: 32, borderRadius: 16, border: 'none', background: '#eee', cursor: 'pointer' }}
                  onClick={() => {
                    let baseQty = inputValues[item.id] !== undefined
                      ? parseFloat(inputValues[item.id].replace(',', '.'))
                      : parseFloat(item.quantity);
                    let newQty;
                    if (isKg) {
                      newQty = Number((baseQty + 0.1).toFixed(3));
                    } else {
                      newQty = Math.floor(baseQty + 1);
                    }
                    const qtyToSend = isKg ? newQty.toFixed(3) : String(newQty);
                    setInputValues(prev => ({
                      ...prev,
                      [item.id]: isKg ? qtyToSend.replace('.', ',') : qtyToSend,
                    }));
                    handleCheckoutActions(
                      checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                      item.product?.product_id || '',
                      qtyToSend
                    );
                  }}
                >
                  +
                </button>
              </div>
            </div>
          );
        })
      ) : (
        <div>Carrinho vazio :(</div>
      )}
    </div>
  );
};

export default Checkout;
